import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44291d52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sso-user-popover inline-block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Lihat user SSO", -1))
const _hoisted_3 = { class: "sso-popover-content" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center py-4"
}
const _hoisted_5 = {
  key: 1,
  class: "text-neutral-500 italic text-center py-2 text-xs"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "sso-table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "sso-label" }, "Username:", -1))
const _hoisted_9 = { class: "sso-value" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "sso-label" }, "Email:", -1))
const _hoisted_11 = { class: "sso-value" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "sso-label" }, "No. Telepon:", -1))
const _hoisted_13 = { class: "sso-value" }

import { ref } from 'vue'
import OverlayPanel from 'primevue/overlaypanel'
import ProgressSpinner from 'primevue/progressspinner'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'

interface ISsoUserData {
  id: string
  username: string
  email: string
  firstName?: string
  lastName?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SsoUserPopover',
  props: {
  authUserId: {
    type: String,
    default: null
  },
  phoneNumber: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props



const ssoCache = new Map<string, ISsoUserData>()

const op = ref()
const isOpen = ref(false)
const isLoading = ref(false)
const errorMessage = ref('')
const userData = ref<ISsoUserData | null>(null)

const togglePopover = async (event: Event) => {
  if (!props.authUserId) return

  op.value.toggle(event)

  if (ssoCache.has(props.authUserId)) {
    userData.value = ssoCache.get(props.authUserId) || null
    errorMessage.value = ''
    return
  }

  isLoading.value = true
  errorMessage.value = ''
  try {
    const res = await apiOpenUseCase.get(`talent/v1/externalAuth/users/${props.authUserId}`)
    const data = res?.result
    if (data && (data.username || data.id)) {
      userData.value = data
      ssoCache.set(props.authUserId, data)
    } else {
      errorMessage.value = 'Data SSO tidak ditemukan'
    }
  } catch (err) {
    console.error('Error fetching SSO user:', err)
    errorMessage.value = 'Data SSO tidak ditemukan'
  } finally {
    isLoading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: "btn-sso-link",
      onClick: togglePopover
    }, [
      _hoisted_2,
      _createElementVNode("i", {
        class: _normalizeClass(["pi pi-chevron-right text-xs", { 'rotate-90': isOpen.value }])
      }, null, 2)
    ]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op,
      showCloseIcon: false,
      onShow: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = true)),
      onHide: _cache[1] || (_cache[1] = ($event: any) => (isOpen.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_unref(ProgressSpinner), {
                  style: {"width":"30px","height":"30px"},
                  strokeWidth: "4"
                })
              ]))
            : (errorMessage.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(errorMessage.value), 1))
              : (userData.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("table", _hoisted_7, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_8,
                          _createElementVNode("td", _hoisted_9, _toDisplayString(userData.value.username || '-'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_10,
                          _createElementVNode("td", _hoisted_11, _toDisplayString(userData.value.email || '-'), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_12,
                          _createElementVNode("td", _hoisted_13, _toDisplayString(__props.phoneNumber || '-'), 1)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}
}

})